export default __webpack_public_path__ + "static/media/ambivert.181946e9.svg";